import React, { useState } from "react";
import TrainingLogin from "./TrainingLogin";
import TrainingList from "./TrainingList";

const TrainingAlert = () => {
  const [show, setShow] = useState(false);
  return <>{!show ? <TrainingLogin setShow={setShow} /> : <TrainingList />}</>;
};

export default TrainingAlert;
